import ADMIN_ROUTES from "./routes";

export { ADMIN_ROUTES };
